// =====================================================================
// bordereaux/theme.js — M-015 : palette du module « Remise transporteur » (validée sur la maquette PDA)
// Partagée par Bordereaux.jsx et l'onglet « ⏰ Automatique » (BordereauxAuto.jsx, 27-10-2026).
// =====================================================================

export const C = {
  paper: '#EEF2F5', surface: '#FFFFFF', surface2: '#F5F8FA', sunken: '#E3EAEF',
  ink: '#16202B', ink2: '#48606F', ink3: '#7A8F9C',
  line: '#D5DFE6', lineStrong: '#B4C4CE',
  accent: '#0E6E6E', accentInk: '#FFFFFF', accentSoft: '#DCEDEC',
  ok: '#17703F', okSoft: '#DBEFE2',
  crit: '#A32B22', critSoft: '#F8E3E1',
  warn: '#9A5B00', warnSoft: '#FCEFD9',
};

// Couleur de repère par transporteur — stable, calculée sur le nom.
const TEINTES = ['#0E6E6E', '#8A4B1E', '#39507A', '#6B2E6B', '#1F6B3A', '#8A2F3F', '#3E5A20', '#6B4A18'];
export const teinte = (nom) => TEINTES[[...String(nom)].reduce((a, ch) => a + ch.charCodeAt(0), 0) % TEINTES.length];
